/**
 * Valida RUT chileno (cuerpo + dígito verificador).
 * Acepta formato con o sin guión: 12345678-9, 12.345.678-K.
 * Para uso con Vuelidate: retorna true si está vacío (dejar que "required" lo maneje).
 */
export function rutChileno(value: string): boolean {
  if (!value || typeof value !== "string") return true;
  const rut = value.replace(/\./g, "").replace(/\s/g, "").toUpperCase();
  if (rut.length < 2) return false;
  const match = rut.match(/^(\d{7,8})-?([\dK])$/);
  if (!match) return false;
  const cuerpo = match[1];
  const dvIngresado = match[2];
  let suma = 0;
  let multiplicador = 2;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo[i], 10) * multiplicador;
    multiplicador = multiplicador > 6 ? 2 : multiplicador + 1;
  }
  const resto = 11 - (suma % 11);
  const dvEsperado = resto === 11 ? "0" : resto === 10 ? "K" : String(resto);
  return dvEsperado === dvIngresado;
}
